<loader [loading]="isLoading()" loadingContentContainerClass="h-100" >
  <router-outlet />
</loader>
<toast-notifications />